  $(document).ready(function() {
     $('.slider-home-v3').slick({ 
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,      
        infinite:false,
        dots: false       
      });
      $('.mobile-slider').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,      
          infinite:false,
          dots: true,
           responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2
              }
            }
          ]
      	});
    if ($(window).width() < 1201) {

      $('#livTabContent').on('afterChange', function(event, slick, direction){
        
         $('#livTab').find('.nav-link').removeClass('active');
         $('#livTab').find('.slick-current').find('.nav-link').addClass('active');
      	}).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,      
          infinite:false,
          dots: false,   
  		  asNavFor: '#livTab'
      });
     
         $('#livTab').slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          asNavFor: '#livTabContent',
          arrows: true,      
          infinite:false,
  		  focusOnSelect: true,
          dots: false,
           responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5
              }
            },             
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 475,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 374,
              settings: {
                slidesToShow: 1
              }
            }
          ]
      	});

     ;
      
      $('#livTabContent').find('.tab-pane').addClass('active').addClass('show');
      $('#livTab').find('.nav-link').on('click',function(){
      	$('#livTab').find('.nav-link').removeClass('active');
        $(this).addClass('active');
        let tab = $(this).attr('aria-controls');

        
      })
      
     
    }
    
  })